const isObject = require('lodash/isObject');
const isArray = require('lodash/isArray');
const truncate = require('lodash/truncate');
const get = require('lodash/get');

const replaceTextWithValues = (
  string,
  values,
  truncateLength,
) => {
  if (!string || typeof string !== 'string') {
    return '';
  }

  const value = string.replace(/%{([\w\s.|\[\]]+)}/g, match => {
    const field = match.replace(/(%{|})/g, '');
    const [ path, defaultValue ] = field.split(/[|]/g);

    const customisation = get(values, path);

    if (typeof customisation === 'undefined' || customisation === null) {
      return defaultValue || match;
    }

    if (isArray(customisation)) {
      return customisation.join(', ');
    }

    if (isObject(customisation) && customisation.label) {
      return customisation.label;
    }

    return customisation;
  });

  return truncateLength
    ? truncate(value, { length: truncateLength, separator: /[,\n]+/ })
    : value;
};


const replaceRichText = (richText = [], values, truncateLength) =>
  richText.map(element => ({
    ...element,
    text: replaceTextWithValues(element.text, values, truncateLength),
  }));

module.exports = {
  replaceTextWithValues,
  replaceRichText,
};
